import { useCallback, useEffect, useState } from 'react';
import { trackLinkAPI } from '../../api/track';

// 배송조회 자료 — 토큰으로 한 번 읽고, 진행 중(배차 대기·예약·픽업지/도착지 이동)이면 20초마다 다시 읽는다(탭이 보일 때만).
// status: loading(처음) · ok(order 또는 null=자료 준비 중) · invalid(없음·만료·닫힘) · error(서버 응답 없음)
const POLL_MS = 20 * 1000;
const LIVE_PHASES = ['waiting', 'reserved', 'to_pickup', 'to_dest'];

export default function useTrackOrder(token) {
  const [state, setState] = useState({ status: 'loading', order: null, serial: '' });

  const load = useCallback(async () => {
    const res = await trackLinkAPI(token);
    if (!res) return;
    if (res.status === 404) { setState({ status: 'invalid', order: null, serial: '' }); return; }
    if (res.status !== 200 || !res.data) {
      setState((prev) => (prev.status === 'ok' ? prev : { status: 'error', order: null, serial: '' }));
      return;
    }
    setState({ status: 'ok', order: res.data.order || null, serial: res.data.serial_number || '' });
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const phase = state.order ? state.order.phase : '';
  const live = state.status === 'ok' && (!state.order || LIVE_PHASES.includes(phase));

  useEffect(() => {
    if (!live) return undefined;
    const id = window.setInterval(() => { if (document.visibilityState === 'visible') load(); }, POLL_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') load(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { window.clearInterval(id); document.removeEventListener('visibilitychange', onVisible); };
  }, [live, load]);

  return { ...state, refresh: load };
}
